import { PrismicNextLink } from '@prismicio/next';
import { Content, asText } from '@prismicio/client';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

// Components
import { Box, Heading, Icon } from '@preventx/oxygen';
import { RichTextDefault } from '@/components/RichText/RichTextDefault';

type FeatureProps = {
  slice: Content.SubMenuItemSliceFeature;
};

export const Feature = ({ slice }: FeatureProps) => {
  const { primary } = slice;
  const { link, caption, feature_title } = primary;

  return (
    <Box component="div" addFlow className="well">
      <Heading addEyebrow component="h3">
        {asText(feature_title)}
      </Heading>

      {caption && <RichTextDefault content={caption} />}

      <PrismicNextLink
        className="button"
        data-type="button-primary"
        field={slice.primary.link}
      >
        {link.text}
        <Icon icon={faArrowRight} />
      </PrismicNextLink>
    </Box>
  );
};
